import { render, staticRenderFns } from "./InvestmentSolutionsHeader.vue?vue&type=template&id=59127ed1&"
import script from "./InvestmentSolutionsHeader.vue?vue&type=script&lang=js&"
export * from "./InvestmentSolutionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentSolutionsHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports